
import { HttpClient, HttpErrorResponse, HttpHeaders, HttpParams } from '@angular/common/http';
import { Injectable, OnInit } from '@angular/core';
import { BehaviorSubject, Observable, throwError as observableThrowError } from 'rxjs';
import { catchError, tap } from 'rxjs/operators';
import { FindAllScopePatternNumberListRequest } from '../../core/models/findAllScopePatternNumberListRequest';
import { FindAllScopePatternNumberListResponse } from '../../core/models/findAllScopePatternNumberListResponse';
import { FindOneScopePatternNumberResponse } from '../../core/models/findOneScopePatternNumberResponse';
import { ResultStatus } from '../../core/models/resultStatus';
import { ScopePatternFilterRequest } from '../../core/models/scopePatternFilterRequest';
import { ScopePatternFilterResponse } from '../../core/models/scopePatternFilterResponse';
import { ScopePatternParamsRefDataResponse } from '../../core/models/scopePatternParamsRefDataResponse';
import { SolrSanitizer } from '../../shared/solr-sanitizer.util';
// import {Observable} from 'rxjs';
const httpOptions = {
  headers: new HttpHeaders({
    'Content-Type': 'application/json',
    //'Authorization': environment.authorization
  }),

};
@Injectable()
export class ScopePatternService implements OnInit {
  private scopePatternAPIUrl: string;
  private scopePatternParamsRefDataResponse = new BehaviorSubject<ScopePatternParamsRefDataResponse | null>(null);
  private findAllScopePatternNumberListResponse = new BehaviorSubject<FindAllScopePatternNumberListResponse | null>(null);
  private findOneScopePatternNumberResponse = new BehaviorSubject<FindOneScopePatternNumberResponse | null>(null);
  private scopePatternFilterResponse = new BehaviorSubject<ScopePatternFilterResponse | null>(null);
  private endpointURL_scopePattern = 'scopePattern';
  private endpointURL_scopepattern_search_by_filter = 'solr-search/scopePattern'

  // private endpointURL_videos = 'video/all';
  // private endpointURL_channels = 'channel/all';
  private endpointURL_scopePatterns_by_maingroup = 'scopePattern/mainGroup/';

  constructor(private http: HttpClient) {
    //this.scopePatternAPIUrl = environment.scopePatternAPIUrl;
  }

  ngOnInit() {
    //this.scopePatternAPIUrl = environment.scopePatternAPIUrl;
  }

  getScopePatternDataByFilter(scopePatternFilterRequest: ScopePatternFilterRequest, make: string): Observable<any> {

    const url = this.endpointURL_scopepattern_search_by_filter;
    let paramsScopePatternFilter = new HttpParams();
    if (!((scopePatternFilterRequest.mainGroup === null || scopePatternFilterRequest.mainGroup === undefined))) {
      paramsScopePatternFilter = paramsScopePatternFilter.append('mainGroup', SolrSanitizer.sanitizeFilterValue(scopePatternFilterRequest.mainGroup));
    }    
    if (!((scopePatternFilterRequest.seriesFilterList === null || scopePatternFilterRequest.seriesFilterList === undefined))) {
      const sanitizedSeriesList = scopePatternFilterRequest.seriesFilterList.map(series => SolrSanitizer.sanitizeFilterValue(series)).join(',').replace(/,\s*$/, "");
      paramsScopePatternFilter = paramsScopePatternFilter.append('seriesList', sanitizedSeriesList);
    }

    if (!((scopePatternFilterRequest.signalsFilterList === null || scopePatternFilterRequest.signalsFilterList === undefined))) {
      const sanitizedSignalsList = scopePatternFilterRequest.signalsFilterList.map(signal => SolrSanitizer.sanitizeFilterValue(signal)).join(',').replace(/,\s*$/, "");
      paramsScopePatternFilter = paramsScopePatternFilter.append('signalsList', sanitizedSignalsList);
    }
    else
    {
      paramsScopePatternFilter = paramsScopePatternFilter.append('signalsList','');
    }

    paramsScopePatternFilter = paramsScopePatternFilter.append('makeName', SolrSanitizer.sanitizeFilterValue(make));

    const httpOptionsParams = {
      headers: new HttpHeaders({
        'Content-Type': 'application/json',
        //'Authorization': environment.authorization
      }),
      params: paramsScopePatternFilter
    };
    return this.http.get(url, httpOptionsParams)
      .pipe(
        tap(data => this.scopePatternFilterResponse.next(data)),
        catchError(err => this.handleHttpError(err))
      );
  }

  // get all noise catalog
  getScopePatternData(): Observable<any> {
    return this.http.get(this.endpointURL_scopePattern, { withCredentials: true });
  }

  // get all signals
  getAllSignals(): Observable<any> {
    return this.http.get(this.endpointURL_scopePattern + "/signalsList", { withCredentials: true });
  }

  // get all catalogs
  getAllCatalogs(): Observable<any> {
    return this.http.get(this.endpointURL_scopePattern + "/makeCatalog", { withCredentials: true });
  }
  
  // get videos with channel id
  getScopePatternsFromMaingroup(maingroupNumber): Observable<any> {
    return this.http.get(this.endpointURL_scopePatterns_by_maingroup + maingroupNumber, { withCredentials: true });
  }

  findAllScopePatternParamsRefData(make: string): Observable<ScopePatternParamsRefDataResponse | ResultStatus> {
    //const url = `${this.scopePatternAPIUrl}` + `/` + `tisParam/findAllScopePatternParamsRefData`;
    const url = `scopePattern/all/`+ make; // `tisParam/findAllScopePatternParamsRefData`;
    // return of(sampleScopePatternParamsRefData);
    return this.http.get<ScopePatternParamsRefDataResponse>(url, httpOptions)
      .pipe(
        tap(data => this.scopePatternParamsRefDataResponse.next(data)),
        catchError(err => this.handleHttpError(err))
      );
  }

  findAllScopePatternNumberList(findAllScopePatternNumberListRequest: FindAllScopePatternNumberListRequest): Observable<FindAllScopePatternNumberListResponse | ResultStatus> {
    const url = `scopePattern`;
    let paramsMakeName = new HttpParams();
    paramsMakeName = paramsMakeName.append('makeName', findAllScopePatternNumberListRequest.makeName);
    // return of(sampleScopePatternParamsRefData);
    
    const httpOptionsParams = {
      headers: new HttpHeaders({
        'Content-Type': 'application/json',

      }),
      params: paramsMakeName
    };
    return this.http.get<FindAllScopePatternNumberListResponse>(url, httpOptionsParams)
      .pipe(
        tap(data => this.findAllScopePatternNumberListResponse.next(data)),
        catchError(err => this.handleHttpError(err))
      );
  }

  // getScopePatternInfo(docNumber, makeName): Observable<any> {
  //   return this.http.get(`scopePattern/findOneScopePatternNumber/${docNumber}?makeName=${makeName}`);
  // }

  findOneScopePatternNumber(scopePatternId): Observable<FindOneScopePatternNumberResponse | ResultStatus> {
    //const url = `scopePattern/findOneScopePatternNumber`;
    const url = `scopePattern/` + scopePatternId;
    let paramsScopePatternNumber = new HttpParams();
    //paramsScopePatternNumber = paramsScopePatternNumber.append('docNumber', decodeURIComponent(findOneScopePatternNumberRequest.docNumber));
    //paramsScopePatternNumber = paramsScopePatternNumber.append('makeName', findOneScopePatternNumberRequest.makeName);
    // return of(sampleScopePatternParamsRefData);

    const httpOptionsParams = {
      headers: new HttpHeaders({
        'Content-Type': 'application/json',
      }),
      params: paramsScopePatternNumber
    };

    return this.http.get<FindOneScopePatternNumberResponse>(url, httpOptionsParams)
      .pipe(
        tap(data => this.findOneScopePatternNumberResponse.next(data)),
        catchError(err => this.handleHttpError(err))
      );
  }
  
  private handleHttpError(error: HttpErrorResponse): Observable<ResultStatus> {

    let errorStatus = new ResultStatus();
    if (error.error instanceof ErrorEvent) {
      // A client-side or network error occurred. Handle it accordingly.
      console.error('An error occurred:', error.error.message);
      // errorStatus.statusCode = error.error.
      // errorStatus.errorCode = error.statusText;
      errorStatus.errorMessage = error.error.message;
      errorStatus.errorDetails = 'An error has occurred. ' + errorStatus.errorMessage + ".";

    }
    else {
      // The backend returned an unsuccessful response code.
      // The response body may contain clues as to what went wrong,
      console.error(
        `Backend returned code ${error.status}, ` +
        `body was: ${error.error}`);
      //errorStatus.errorDetails = 'An error has occurred. ' +error.status + ' ' + error.statusText +".";
      errorStatus.errorDetails = 'Backend service is unavailable. Try again after sometime.';
      // errorStatus.errorDetails = 'Affected backend system is currently down / in maintenance mode.Error is - : ' + errorStatus.statusCode + ' (' + errorStatus.errorCode + ')';
    }
    // return an observable with a user-facing error message
    return observableThrowError(
      'Something bad happened; please try again later.');
    // return throwError(errorStatus);
    //return;
  }
}



const sampleScopePatternParamsRefData =
{
  "status": {
    "statusCode": "SUCCESS"
  },
  "scopePatternDataParams": {
    "MINI": {
      "area": ["Body and Trim", "Infotainment", "Electrics / Electronics", "Chassis and Suspension", "Powertrain"],
      "component": ["Steering gear", "Steering column", "Stabilizer links", "Suspension links", "Struts", "Wheel bearings", "Wheels", "Brake pads", "Brake rotors", "Parking brake", "DSC", "EMF", "Window", "Glass", "Body", "Sunroof", "Door", "Seats", "Interior trim", "Dashboard", "Valve lifters", "Pistons/Rings", "Ignition", "Injectors", "Timing chain/Tensioner", "Belt drive/Pulleys/Belt tensioner", "Water pump", "Vacuum pump", "Oil pump/Chain", "Alternator", "Turbocharger/Wastegate actuators", "Crankshaft/main bearings/conrod bearings", "Crank ventilation system (TEV valve)", "Clutch/Bearing/Flywheel", "Transmission/Torque converter", "Driveshaft/Flexible discs", "Transfer case", "Differential (gears and limited slip components)", "Fuel tank/Fuel pump", "Springs and shocks", "Engine/Transmission mounts (hydraulic and vacuum)", "Shifter (mechanical)", "High Voltage Compressor", "eMachine / transmission noises (bearings)", "REx Engine / REx Generator", "Cooling Fan", "PHEV: eMachine during regeneration when HV battery is almost depleted"],
      "driveConditions": ["Cold start", "Acceleration", "Constant speed", "Braking high speed", "Braking low speed", "Turning", "Parking"],
      "weatherConditions": ["Low temperatures (below 40 F)", "High temperatures (above 40 F)", "Rain", "Snow", "Ice"],
      "kindOfNoise": ["Rattling ", "Knocking", "Grinding/Rubbing", "Squeaking / Squealing", "Whistling/Hissing", "Humming/Drone", "Howling", "Cracking / Creaking", "Clicking", "Buzzing"],
      "sporadicOrPermanent": ["SPORADIC", "PERMANENT"]
    },
    "BMW": {
      "area": ["Body and Trim", "Infotainment", "Electrics / Electronics", "Chassis and Suspension", "Powertrain"],
      "component": ["Steering gear", "Steering column", "Stabilizer links", "Suspension links", "Struts", "Wheel bearings", "Wheels", "Brake pads", "Brake rotors", "Parking brake", "DSC", "EMF", "Window", "Glass", "Body", "Sunroof", "Door", "Seats", "Interior trim", "Dashboard", "Valve lifters", "Pistons/Rings", "Ignition", "Injectors", "Timing chain/Tensioner", "Belt drive/Pulleys/Belt tensioner", "Water pump", "Vacuum pump", "Oil pump/Chain", "Alternator", "Turbocharger/Wastegate actuators", "Crankshaft/main bearings/conrod bearings", "Crank ventilation system (TEV valve)", "Clutch/Bearing/Flywheel", "Transmission/Torque converter", "Driveshaft/Flexible discs", "Transfer case", "Differential (gears and limited slip components)", "Fuel tank/Fuel pump", "Springs and shocks", "Engine/Transmission mounts (hydraulic and vacuum)", "Shifter (mechanical)", "High Voltage Compressor", "eMachine / transmission noises (bearings)", "REx Engine / REx Generator", "Cooling Fan", "PHEV: eMachine during regeneration when HV battery is almost depleted"],
      "driveConditions": ["Cold start", "Acceleration", "Constant speed", "Braking high speed", "Braking low speed", "Turning", "Parking"],
      "weatherConditions": ["Low temperatures (below 40 F)", "High temperatures (above 40 F)", "Rain", "Snow", "Ice"],
      "kindOfNoise": ["Rattling ", "Knocking", "Grinding/Rubbing", "Squeaking / Squealing", "Whistling/Hissing", "Humming/Drone", "Howling", "Cracking / Creaking", "Clicking"],
      "sporadicOrPermanent": ["SPORADIC", "PERMANENT"]
    },
    "MOTORRAD": {
      "area": ["Body and Trim", "Infotainment", "Electrics / Electronics", "Chassis and Suspension", "Powertrain"],
      "component": ["Steering gear", "Steering column", "Stabilizer links", "Suspension links", "Struts", "Wheel bearings", "Wheels", "Brake pads", "Brake rotors", "Parking brake", "DSC", "EMF", "Window", "Glass", "Body", "Sunroof", "Door", "Seats", "Interior trim", "Dashboard", "Valve lifters", "Pistons/Rings", "Ignition", "Injectors", "Timing chain/Tensioner", "Belt drive/Pulleys/Belt tensioner", "Water pump", "Vacuum pump", "Oil pump/Chain", "Alternator", "Turbocharger/Wastegate actuators", "Crankshaft/main bearings/conrod bearings", "Crank ventilation system (TEV valve)", "Clutch/Bearing/Flywheel", "Transmission/Torque converter", "Driveshaft/Flexible discs", "Transfer case", "Differential (gears and limited slip components)", "Fuel tank/Fuel pump", "Springs and shocks", "Engine/Transmission mounts (hydraulic and vacuum)", "Shifter (mechanical)", "High Voltage Compressor", "eMachine / transmission noises (bearings)", "REx Engine / REx Generator", "Cooling Fan", "PHEV: eMachine during regeneration when HV battery is almost depleted"],
      "driveConditions": ["Cold start", "Acceleration", "Constant speed", "Braking high speed", "Braking low speed", "Turning", "Parking"],
      "weatherConditions": ["Low temperatures (below 40 F)", "High temperatures (above 40 F)", "Rain", "Snow", "Ice"],
      "kindOfNoise": ["Rattling ", "Knocking", "Grinding/Rubbing", "Squeaking / Squealing", "Whistling/Hissing", "Humming/Drone", "Howling", "Cracking / Creaking", "Clicking", "Buzzing"],
      "sporadicOrPermanent": ["SPORADIC", "PERMANENT"]
    }
  }
}
